import React from "react"

import logo from "../../assets/img/BlackLogo.svg"
import chiliLogo from "../../assets/img/ChiliRed.svg"

const Header = ({ text }) => {
    return (
        <>
            <div className="pt-4 pb-2 w-full gap-2 flex justify-center">
                <img
                    src={logo}
                    className="h-6 opacity-75 pr-1"
                    alt="Hotspot logo"
                />
                <img
                    src={chiliLogo}
                    className="h-6 opacity-75"
                    alt="Hotspot Chili logo"
                />
            </div>

            <h1 className="text-3xl font-bold text-primary-500 text-center pb-4">
                {text}
            </h1>
        </>
    )
}

export default Header
